import MiniSearch from 'minisearch';
import { useStore } from 'stimulus-store';
import { Liquid } from 'liquidjs';

import ApplicationController from './application_controller';
import searchDocumentsStore from '../stores/search_documents_store';

const engine = new Liquid();

export default class extends ApplicationController {
  static stores = [searchDocumentsStore];

  static targets = [
    'queryInput',
    'resultsTemplate',
    'results',
  ];

  static values = {
    results: {
      type: Array,
      default: [],
    },
  };

  connected() {
    useStore(this);

    this.miniSearch = new MiniSearch({
      fields: ['title', 'text'],
      storeFields: ['title', 'text', 'type', 'url'],
    });

    if (this.searchDocumentsStoreValue.length === 0) {
      this.#loadDocuments();
    } else {
      this.#initSearch();
    }
  }

  resultsValueChanged() {
    this.#renderResults();
  }

  resultsTemplateTargetConnected() {
    this.resultsTemplate = this.resultsTemplateTarget.textContent;
  }

  onSearchDocumentsStoreUpdate() {
    if (this.miniSearch) this.#initSearch();
  }

  onDocumentsFetched(data) {
    this.setSearchDocumentsStoreValue(
      data.map((doc, id) => ({ id, ...doc }))
    );
  }

  submit() {
    this.resultsValue = this.miniSearch.search(
      this.queryInputTarget.value,
    )
  }

  #loadDocuments() {
    fetch('/api/search-documents.json')
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then(this.onDocumentsFetched.bind(this))
      .catch((error) => {
        console.error('Error fetching the JSON file:', error);
      });
  }

  #initSearch() {
    this.miniSearch.addAll(this.searchDocumentsStoreValue);
  }

  #renderResults() {
    if (this.resultsValue.length === 0) {
      this.resultsTarget.innerHTML = '';
      this.resultsTarget.classList.add('hidden');
    } else {
      engine.parseAndRender(
        this.resultsTemplate,
        {
          results: [
            {
              type: 'Pages',
              list: this.resultsValue.filter(result => result.type === 'page'),
            },
            {
              type: 'Use Cases',
              list: this.resultsValue.filter(result => result.type === 'use_case'),
            },
            {
              type: 'Posts',
              list: this.resultsValue.filter(result => result.type === 'post'),
            },
          ],
        }
      )
        .then(((html) => {
          this.resultsTarget.innerHTML = html;
          this.resultsTarget.classList.remove('hidden');
        }).bind(this));
    }
  }
}
